import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-refresh-mode-picker', {
    display: 'inline-block',
    marginLeft: '6px',
    minWidth: '150px',
    verticalAlign: 'middle',
});

cssRule('.tb-details-refresh-mode-picker', {
    whiteSpace: 'normal',
});

cssRule('.tb-details-refresh-mode-picker-description', {
    color: applyColor(DesignTokens.color.font.default.subtle, '#999'),
    lineHeight: '16px',
});

cssRule('.tb-details-refresh-agent-picker', {
    display: 'inline-block',
    width: '400px',
});

cssRule('.tb-details-refresh-mode-block-first', {
    paddingBottom: '12px',
});

cssRule('.tb-details-refresh-mode-block', {
    paddingTop: '12px',
    paddingBottom: '12px',
});

cssRule('.tb-details-refresh-mode-block-last', {
    paddingTop: '12px',
    paddingBottom: 0,
});

cssRule('.tb-details-refresh-mode-select-group-body', {
    paddingLeft: '21px',
});

cssRule('.tb-details-refresh-mode-select-selector', {
    display: 'inline-block',
    width: '350px',
});

